
import { Crown, Shield, User, UserRound, Users } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UserRole } from "../types";
import { useUser } from "@/contexts/UserContext";

interface UserRoleSelectProps {
  defaultValue: UserRole;
  onValueChange: (value: UserRole) => void;
  disabled?: boolean;
}

export const UserRoleSelect = ({ 
  defaultValue, 
  onValueChange, 
  disabled = false 
}: UserRoleSelectProps) => {
  const { isSuperAdmin } = useUser();

  return (
    <Select
      defaultValue={defaultValue}
      onValueChange={onValueChange}
      disabled={disabled}
    >
      <SelectTrigger className="w-32">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {isSuperAdmin && (
          <SelectItem value="admin">
            <div className="flex items-center">
              <Shield className="mr-2 h-4 w-4" />
              Admin
            </div>
          </SelectItem>
        )}
        <SelectItem value="manager">
          <div className="flex items-center">
            <Users className="mr-2 h-4 w-4" />
            Manager
          </div>
        </SelectItem>
        <SelectItem value="guard">
          <div className="flex items-center">
            <User className="mr-2 h-4 w-4" />
            Guard
          </div>
        </SelectItem>
        <SelectItem value="client">
          <div className="flex items-center">
            <UserRound className="mr-2 h-4 w-4" />
            Client
          </div>
        </SelectItem>
      </SelectContent>
    </Select>
  );
};
